import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FormGroup from '~/commons/components/FormGroup.jsx';
import Alert from '~/commons/components/Alert.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import { numToLetter } from '~/commons/helpers';

export const defaultQtn = {
  question: '',
  img: null,
  choices: [],
  answer: null,
  tips: '',
};
export const defaultQtnSet = (i) => ({
  refCode: numToLetter(i).toUpperCase(),
  draw: 0,
  questions: [defaultQtn],
});

const FieldsCompQtnSet = ({ fileUploadUrl, answered, idx }) => (
  <div className="pt-3">
    {answered && (
      <Alert theme="warning">
        Some of the users have already answered these questions. Only limited
        changes can be made.
      </Alert>
    )}
    <FormGroup
      name={`questionSets[${idx}].refCode`}
      label="Subject / Reference Code"
      required
    />
    <FormGroup
      name={`questionSets[${idx}].draw`}
      type="number"
      label="No. of draw"
      helpText="How many questions will be picked randomly from this question bank"
      required
    />

    <label>Questions</label>
    <FieldArrayIterables
      name={`questionSets[${idx}].questions`}
      {...(answered
        ? {}
        : {
          push: defaultQtn,
        })}
    >
      {(q, i, { remove }) => (
        <div key={i} className="card mb-3">
          {!answered && (
            <button className="btn btn-link close" onClick={() => remove(i)}>
              <FA icon={faTimes} size="sm" />
            </button>
          )}
          <div className="card-body">
            <div className="row">
              <div className="col">
                <FormGroup
                  name={`questionSets[${idx}].questions.${i}.question`}
                  as="summernote"
                  label={`${i + 1}. Question`}
                  fileUploadUrl={fileUploadUrl}
                  required
                  toolbar={[
                    ['style', ['style']],
                    [
                      'font',
                      [
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        'superscript',
                        'subscript',
                        'color',
                        'clear',
                        ['view', ['codeview', 'undo', 'redo']],
                      ],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                  ]}
                />

                <label>Choices *</label>
                <FieldArrayIterables
                  name={`questionSets[${idx}].questions.${i}.choices`}
                  {...(answered
                    ? {}
                    : {
                      tail: '',
                    })}
                >
                  {(c, ii) => (
                    <div className="form-row align-items-center" key={ii}>
                      <div className="col-auto pb-3">
                        {numToLetter(ii, true)}.
                      </div>
                      <div className="col">
                        <FormGroup
                          radio={{
                            name: `questionSets[${idx}].questions.${i}.answer`,
                            value: ii.toString(),
                          }}
                          name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                          label={null}
                        />
                      </div>
                    </div>
                  )}
                </FieldArrayIterables>
              </div>
              <div className="col">
                <FormGroup
                  className="contain"
                  name={`questionSets[${idx}].questions.${i}.img`}
                  as="coverImg"
                  label="Image (suggested dimension: 1280 x 960px)"
                  api={fileUploadUrl}
                />
              </div>
              <div className="col">
                <FormGroup
                  name={`questionSets[${idx}].questions.${i}.tips`}
                  as="summernote"
                  label="Tips"
                  fileUploadUrl={fileUploadUrl}
                  defaultValue={q.tips || ''}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </FieldArrayIterables>
  </div>
);

export default FieldsCompQtnSet;
